import React from 'react';

export const SwitchesCategory = (props) => (
    <svg {...props} viewBox="0 0 24 24" fill="none">
        <path d="M18.8 0H5.2C2.4 0 0 2.4 0 5.2C0 8.1 2.4 10.4 5.2 10.4H18.7C21.6 10.4 23.9 8 23.9 5.2C24 2.4 21.6 0 18.8 0ZM5.2 7.5C4 7.5 3 6.5 3 5.2C3 3.9 4 3 5.2 3C6.4 3 7.4 4 7.4 5.2C7.4 6.4 6.5 7.5 5.2 7.5ZM18.8 13.5H5.2C2.3 13.5 0 15.9 0 18.7C0 21.5 2.4 24 5.2 24H18.7C19.1 24 19.4 24 19.8 23.9C21.9 23.5 23.5 21.9 23.9 19.8C24 19.5 24 19.1 24 18.7C24 15.9 21.6 13.5 18.8 13.5ZM14 21H5.2C4 21 3 20 3 18.8C3 17.6 4 16.6 5.2 16.6H14C13.7 17.3 13.5 18 13.5 18.8C13.5 19.6 13.7 20.3 14 21ZM18.8 21C17.6 21 16.6 20 16.6 18.8C16.6 17.6 17.6 16.6 18.8 16.6C20 16.6 21 17.6 21 18.8C21 20 20 21 18.8 21Z" />
    </svg>
);
export default SwitchesCategory;
